module.exports = {
          srcSet: __webpack_public_path__ + "35c93ea71f83fb70d73a3ac091777434-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "35c93ea71f83fb70d73a3ac091777434-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "35c93ea71f83fb70d73a3ac091777434-60.png",
          toString:function(){return __webpack_public_path__ + "35c93ea71f83fb70d73a3ac091777434-60.png"},
          
          width: 60,
          height: 60
        }